<template>
  <el-dialog
    id="feeCalculation"
    title="费用计算"
    :visible.sync="show"
    destroy-on-close
    @closed="closed"
  >
    <el-form :model="form" ref="form" label-width="100px">
      <el-form-item label="时间范围">
        <el-col :span="11">
          <el-form-item>
            <el-date-picker
              v-model="form.startTime"
              type="datetime"
              placeholder="选择开始时间"
              style="width: 100%;"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col class="line" :span="2">-</el-col>
        <el-col :span="11">
          <el-form-item>
            <el-date-picker
              v-model="form.endTime"
              type="datetime"
              placeholder="选择结束时间"
              style="width: 100%;"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
      </el-form-item>
      <el-button type="primary" @click="confirm" :loading="loading"
        >立即计算</el-button
      >
      <h1>总金额: {{ money }}元</h1>
    </el-form>
  </el-dialog>
</template>

<script>
import moment from "moment";
export default {
  data() {
    return {
      show: false,
      loading: false,
      priceId: "",
      form: {
        startTime: "",
        endTime: "",
      },
      money: 0,
    };
  },
  methods: {
    async confirm() {
      this.loading = true;
      const res = await this.$http.post("/price/compute", {
        priceId: this.priceId,
        startTime: this.form.startTime ? this.form.startTime : null,
        endTime: this.form.endTime ? this.form.endTime : null,
      });
      if (res.code === 0) {
        this.money = res.data;
      } else {
        this.$message.error(res.msg);
      }
      this.loading = false;
    },
    closed() {
      this.form = {
        startTime: "",
        endTime: "",
      };
      this.money = 0;
    },
  },
};
</script>

<style lang="scss">
#feeCalculation {
  .line {
    text-align: center;
  }
  .el-button {
    width: 100%;
    margin-bottom: 20px;
  }
  h1 {
    font-size: 16px;
  }
}
</style>
